<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz17-1"><a id="page_5"></a><a href="#/contents#RR_14" id="CC_14"> Tweeky’s Class Reunion Punch</a></p>
<p class="tx6" id="pz17-2"><i> Unforgettable. </i></p>
<p class="tx5" id="pAz4"><b> 1 large can pineapple juice </b></p>
<p class="tx5" id="pAuM"><b> 1 quart cranberry juice </b></p>
<p class="tx5" id="pAyKI"><b> 1 2-liter bottle pale dry ginger ale </b></p>
<p class="tx5" id="pAj7"><b> 2 12-ounce cans frozen orange juice concentrate </b></p>
<p class="tx1" id="pAvYg"><span class="dcap">F</span>reeze pineapple juice in ring. When frozen, put in bowl with remaining ingredients.</p>
<p class="tx" id="pAaqh"> Makes about 30 punch cups.</p>
<p class="txrr" id="pAHPB"> <i>Diane and Steve McCarty—New Freedom, Pennsylvania</i></p>
<div class="image" id="pAfIB">
<p class="ser"><img alt="images/img-17-1.jpg" id="AfIB" src="images/img-17-1.jpg"/></p>
<p class="txcc" id="pAvs"><i>Barney “Tweeky” Fife</i></p>
</div>
<div class="image" id="pAcu"> <p class="ser"><img alt="images/img-17-2.jpg" id="Acu" src="images/img-17-2.jpg"/></p></div>
<p class="txcc" id="pAiP"> <i>NEED GLASSES?—Andy and Barney strain to recognize faces while manning the punch bowl at their high-school class reunion.</i></p>
<div class="box" id="A8S">
<table>
<tbody style="vertical-align: top;">
<tr>
<td style="width: 30%;"><p class="txtb">ERNEST T. BASS:</p></td>
<td>No coffee, tea, or punch, thank you.</td>
</tr>
</tbody>
</table></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter14.vue?3822487b